<template>
    <Pharmacy></Pharmacy>
    <PatientDme
        :provider-id="patientOptions.data.providerId"
        v-model:dmes="patientDetails.pharmacyAndDme.dmEs"
        :patient-status="patientOptions.data.status"
        v-model:patient-vendors="patientDetails.pharmacyAndDme.dmeVendors"
        :order-id="patientDetails.pharmacyAndDme.associatedTaskId"
        :is-attach-order-not-required="!!patientDetails.pharmacyAndDme.isAttachOrderNotRequired"
    >
    </PatientDme>
    <PatientSupply
        :provider-id="patientOptions.data.providerId"
        v-model:supplies="patientDetails.pharmacyAndDme.supplies"
        :patient-status="patientOptions.data.status"
        v-model:patient-vendors="patientDetails.pharmacyAndDme.supplyVendors"
        :order-id="patientDetails.pharmacyAndDme.associatedTaskId"
        :is-attach-order-not-required="!!patientDetails.pharmacyAndDme.isAttachOrderNotRequired"
    >
    </PatientSupply>
</template>

<script lang="ts" src="./PharmacyAndDme.ts"></script>
